import { useTheme } from '@mui/material';

// Validated categorical palette — copied verbatim from the mock's styles.css (--s1..--s8),
// which was run through the dataviz validator. Fixed order; assign by index, never cycle.
const SERIES_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];
const SERIES_DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];

export const CATEGORICAL = SERIES_LIGHT;

export interface ChartColors {
    series: string[];
    ink: string;
    muted: string;
    grid: string;
    surface: string;
}

export function useChartColors(): ChartColors {
    const dark = useTheme().palette.mode === 'dark';
    return dark
        ? { series: SERIES_DARK, ink: '#f5f5f2', muted: '#898781', grid: '#2c2c2a', surface: '#1a1a19' }
        : { series: SERIES_LIGHT, ink: '#16181f', muted: '#898781', grid: '#e1e0d9', surface: '#fcfcfb' };
}
